import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { User } from '@typings/user';

type InitialState = {
  byId: Record<string, User>;
};

export const initialState: InitialState = {
  byId: {},
};

export const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    setUserDataById: (state, action: PayloadAction<User>) => {
      const oldUserData = state.byId[action.payload.id] || {};
      state.byId[action.payload.id] = { ...oldUserData, ...action.payload };
    },
    setUsersData: (state, action: PayloadAction<User[]>) => {
      action.payload.forEach((user) => {
        const previousData = state.byId[user.id] || {};
        state.byId[user.id] = { ...previousData, ...user };
      });
    },
  },
});

export const { setUserDataById, setUsersData } = usersSlice.actions;

export default usersSlice.reducer;
